import { useState } from "react";
import { Alert, Button, Form, Modal } from "react-bootstrap";
import { editExtraWorkCategory } from '../../../apiMethod/extraWorkCategories.js';

export default function EditExtraWorkCategory({ show, onHide, jwt, id, onUpdate, category }) {
    const [categoryLocal, setCategoryLocal] = useState({
        ...category,
        pcefProcent: category.pcefProcent || 0,
        salary: category.salary || 0
    });

    const onSubmit = async () => {
        const response = await editExtraWorkCategory(id, jwt, categoryLocal.name, categoryLocal.pcefProcent, categoryLocal.salary);
        if (response) {
            onUpdate(categoryLocal);
            onHide();
            return;
        }
        alert('Не удалось изменить');
    };

    return (
        <Modal centered show={show} onHide={onHide}>
            <Form onSubmit={e => e.preventDefault() || onSubmit()}>
                <Modal.Header closeButton>
                    <Modal.Title>Изменить категорию</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Новое название</Form.Label>
                        <Form.Control
                            required
                            type="text"
                            value={categoryLocal.name}
                            onChange={(e) => setCategoryLocal({ ...categoryLocal, name: e.target.value })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Процент ПКЭФ</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            max="500"
                            step="1"
                            value={categoryLocal.pcefProcent}
                            onChange={(e) => setCategoryLocal({ ...categoryLocal, pcefProcent: parseInt(e.target.value) || 0 })}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Оклад</Form.Label>
                        <Form.Control
                            type="number"
                            min="0"
                            step="1"
                            value={categoryLocal.salary}
                            onChange={(e) => setCategoryLocal({ ...categoryLocal, salary: parseInt(e.target.value) || 0 })}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onHide}>Закрыть</Button>
                    <Button variant="success" type="submit">Сохранить</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}